import { render, staticRenderFns } from "./IncomeInvestigationOnboarding.vue?vue&type=template&id=8ecefd42&scoped=true&"
import script from "./IncomeInvestigationOnboarding.vue?vue&type=script&lang=js&"
export * from "./IncomeInvestigationOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./IncomeInvestigationOnboarding.vue?vue&type=style&index=0&id=8ecefd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecefd42",
  null
  
)

export default component.exports